export default "__VITE_ASSET__DuAk7bkY__"